module.exports = __webpack_public_path__ + "img/cloud_down.884116f7.png";